import React, { Component } from "react";
import { Divider, Typography } from "@material-ui/core";
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { 
    putResponse, getQuestion, getQuestionResults, addNote, 
    addQuestionToDeck, updateHeaderInfo, putNextReviewDate, 
    getUserDetails, removeQuestion, resetDeck, 
    trackPage
} from "../actions";
import { QuestionTestCard, CopyrightWidget, LoadingCard, RetiredQuestionTestCard, AILegalStatementCard } from "../components";
import { 
    deviceData, setContainer, scrollTop, getThisYear, preventCopy, hasLegal, getLocalStorage, setLocalStorage, DATA_TEXT_ARRAY
} from "../common";
import { isBrowser } from 'react-device-detect';

import "../styles/masterStyles.css";
import "../styles/questionStyles.css";

class QuestionTestScreen extends Component {
    state = {
        reload: false,
        copyModal: false,
        text: 'test...',
        loading: true,
        data: {},
        answered: -1,
        type: null,
        typetext: 'Specific Question',
        gamemode: 0,
        year: 0,
        refsMats: null,
        spaced: 0,
        deckid: null,
        prevAnswer: {answered: 0},
        completed: 0,
        reviewObj: null,
        loadingtext: 'Loading Test Data.',
        interval: -1
    }

    componentDidMount = async () => {
        preventCopy();
        const { mcid, key } = this.props.auth_feedback;
        const { testYear, gameMode, deckID, questionID } = this.props.location;

        console.log(this.props.location);

        let tracking = deviceData(this.props.location, 'navigate');
        let tobj = {
            mcid: mcid,
            key: key,
            tracking: tracking
        }



        this.props.trackPage(tobj);
        
        scrollTop('QuestionDiv', -64)
        
        await this.props.updateHeaderInfo({
            name: "Questions", 
            iconTwo: 'menu',
            iconOne: 'home',
        });

        let loading = true;
        let cmeYears = [];

        const date = Date.now();
        const ls_user_details = Number(getLocalStorage('sasp_user_DT'))  + (10 * 60 * 1000);
        
        if (getLocalStorage('sasp_user_details') === null || ls_user_details < date ) {
            await this.props.getUserDetails(mcid, key);
        } else {
            loading = false;
            cmeYears = this.props.user_details.cmeYears
        }

        let _obj = { mcid: mcid, key: key }

        if (!isNaN(Number(testYear))) {
            _obj.yearvar = testYear;
        }

        if (!isNaN(Number(deckID))) {
            _obj.deckID = deckID;
        } 

        if (!isNaN(Number(gameMode))) {
            _obj.gamemode = gameMode;
        } 

        if (!isNaN(Number(questionID))) {
            _obj.questionID = questionID;
        } 

        await this.props.getQuestion(_obj);

        let _type = 'open';
        let typetext = 'Open Book';

        if (Number(gameMode) === 2 || Number(gameMode) === 4 || Number(gameMode) === 10 ||  Number(gameMode) === 12) {
            _type = 'closed';
            typetext = 'Closed Book';
        }

        return this.setState({ 
            ...this.state,
            type: _type,
            data: this.props.question,
            gamemode: Number(gameMode),
            deckid: deckID,
            year: testYear,
            typetext: typetext,
            laoding: loading
        })
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.question !== this.props.question) {
            scrollTop('QuestionDiv', -64);

            let _more = Number(this.props.question.morequestions);
            
            if (typeof this.props.question.questionNumber === 'number') {
            }

            if (_more > 0) {
                return this.setState({ 
                    ...this.state,
                    data: this.props.question,
                    answered: -1,
                    loading: false,
                })
            } else {
                switch (Number(this.props.question.gameMode)) {
                    case 1:
                    case 2: {
                        return this.props.history.push('/testResultScreen');
                    }
        
                    case 3:
                    case 4: {
                        return this.props.history.push('/myDecks');
                    }
        
                    default: {
                        return this.props.history.push('/home');
                    }
                }
            }
        }

        if (prevProps.deckList !== this.props.deckList) { }

        if (prevState.data !== this.state.data) {
            const { testYear, gameMode, deckID } = this.props.location;

            let _text = '';
            let _type = 'Open Book';
            let typetext = this.state.typetext;
            let spaced = 0;

            if (Number(gameMode) === 4 || Number(gameMode) === 2 || Number(gameMode) === 10 ) {
                _type = 'Closed Book';
            }

            if (Number(gameMode) === 1 || Number(gameMode) === 2) {
                _text = `${testYear} ${_type} Test`
            } else if (Number(gameMode) === 3 || Number(gameMode) === 4) {
                let _filter = this.props.deckList.find(item => item.deckID === deckID);

                let title = 'Deck';

                if (typeof _filter === 'object' && !Array.isArray(_filter)) {
                    title = _filter.deckname;

                    if (_filter.isspaced) {
                        spaced = _filter.isspaced;
                        typetext = `${_type} (Spaced Learning)`;
                    }
                }

                _text = `${title}`
            } else if (Number(gameMode) === 7) {
                _text = this.state.data.title;
            } else if (Number(gameMode) === 9 || Number(gameMode) === 10) {
                let _filter = this.props.quizzes.find(item => item.deckID === deckID);

                let title = 'Quiz';

                if (typeof _filter === 'object' && !Array.isArray(_filter)) {
                    title = _filter.deckname;
                }

                _text = `${title}`
            }

            await this.setState({
                ...this.state,
                loading: false,
                text: _text,
                spaced: spaced,
                typetext: typetext,
                prevAnswer: this.state.data.prevAnswer ? this.state.data.prevAnswer : {answered: 0}
            })
        }

        if ( prevProps.error !== this.props.error && this.props.error !== '' ) {
            let _error = this.props.error;
            let _question = this.props.question;

            if (typeof _error === 'object' || Array.isArray(_error)) {
                try {
                    _error = JSON.stringify(_error);
                } catch (e) {
                }
            }

            if (typeof _question === 'object' || Array.isArray(_error)) {
                try {
                    _question = JSON.stringify(_question);
                } catch (e) {
                }
            }

            const __obj = {
                pathname: 'error',
                prevLoc: {
                    pathname: this.props.location.pathname,
                    detail: _error,
                    detailvar2: _question
                }
            }
            return <Redirect to={__obj} />
        }
    }

    handleOpen = () => {
        this.setState({
            ...this.state,
            copyModal: true,
        });
    };

    handleClose = () => {
        this.setState({
            ...this.state,
            copyModal: false,
        });
    };

    setColorObj = (type = 'base') => {
        let r;

        switch (type) {
            default: {
                r = {
                    deck: "neutralGreenCard",
                    text: "neutralGreenText",
                    button: "neutralGreenCard"
                }
            }
        }
        return r;
    }

    handleSubmit = async (obj) => {
        this.setState({...this.state, loading: true});

        if (typeof obj.next !== 'undefined' && obj.next !== null) {
            let _goto = {
                mcid: obj.mcid,
                key: obj.key,
                gamemode: this.state.gamemode,
            }

            if (!isNaN(Number(this.state.deckid))) {
                _goto.deckID = this.state.deckid;
            } 

            if (this.state.gamemode < 3) {
                _goto.yearvar = this.state.year;
            }

            if (obj.next > 0) {
                _goto.questionID = obj.next;
            }

            scrollTop('QuestionDiv', -64);
            return this.props.getQuestion(_goto)
        } else if (typeof obj.prev !== 'undefined') {
            let _goto = {
                mcid: obj.mcid,
                key: obj.key,
                gamemode: this.state.gamemode,
            }

            if (!isNaN(Number(this.state.deckid))) {
                _goto.deckID = this.state.deckid;
            } 

            if (this.state.gamemode < 3) {
                _goto.yearvar = this.state.year;
            }

            if (obj.prev > 0) {
                _goto.questionID = obj.prev;
            }
            scrollTop('QuestionDiv', -64)

            return this.props.getQuestion(_goto);
        } else if (typeof obj.answerid !== 'undefined') {
            let data = {
                mcid: obj.mcid,
                key: obj.key,
                questionID: obj.questionid,
                gamemode: this.state.gamemode,
                optionSelected: obj.answerid ? obj.answerid : obj.choice,
                deckID: this.props.location.deckID ? this.props.location.deckID : 0,
                tracking: deviceData(this.props.location, 'submit answer'),
                year: this.state.year ? this.state.year : null
            };

            data.tracking.action = 'answer question';

            if (typeof obj.retired === 'object') {
                let _goto = {
                    mcid: obj.mcid,
                    key: obj.key,
                    gamemode: this.state.gamemode,
                    yearvar: this.state.year
                };

                if (!isNaN(Number(this.state.deckid))) {
                    _goto.deckID = this.state.deckid;
                } 

                if (obj.retired.nextquestionid > 0) {
                    _goto.questionID = obj.retired.nextquestionid;
                }

                await this.props.putResponse(data);

                return this.props.getQuestion(_goto)
            } else if (this.state.gamemode === 2 || this.state.gamemode === 4) {
                await this.setState({ ...this.state, answered: 0, loading: true});

                let _goto = {
                    mcid: obj.mcid,
                    key: obj.key,
                    questionID: obj.next,
                    gamemode: this.state.gamemode,
                    yearvar: this.state.year
                };

                if (!isNaN(Number(this.state.deckid))) {
                    _goto.deckID = this.state.deckid;
                } 

                await this.props.putResponse(data);

                return this.props.getQuestion(_goto) 
            } else if (this.state.gamemode === 9 || this.state.gamemode === 10) {
                await this.setState({ ...this.state, answered: 0, loading: true});

                let _goto = {
                    mcid: obj.mcid,
                    key: obj.key,
                    questionID: obj.next,
                    gamemode: this.state.gamemode,
                    yearvar: this.state.year
                };

                if (!isNaN(Number(this.state.deckid))) {
                    _goto.deckID = this.state.deckid;
                } 
                await this.props.putResponse(data);

                return this.props.getQuestion(_goto)
            }  else {

                this.setState({...this.state, loading: false})

                await this.props.putResponse(data);
                return this.setState({ ...this.state, answered: 1});
            }
        }
    }

    addNote = async (data) => {
        data.questionID = Number(data.questionID);
        this.props.addNote(data);
    }

    addToDecks = async (id, deckID) => {
        let cnt = 0;
        let obj;
        if (!deckID) {
            for (const i in this.props.deckList) {
                obj = {
                    mcid: this.props.auth_feedback.mcid,
                    key: this.props.auth_feedback.key,
                    questionID: id, 
                    deckID: this.props.deckList[i].deckID
                };

                this.props.addQuestionToDeck(obj);
                cnt++
            }
        } else {
            obj = {
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                questionID: id, 
                deckID: deckID
            };

            this.props.addQuestionToDeck(obj);
        }        
    }

    removeQuestion = async(obj) => {
        return this.props.removeQuestion(obj);
    }

    scrollToTop = () => {
        return scrollTop('QuestionDiv', -64);
    }

    resetTest = async (obj) => {
        this.setState({ ...this.state, loading: true });

        await this.props.resetDeck(obj);

        return this.props.history.push('/home');
    }

    _reset = async (obj) => {
        let _path;
        if (typeof obj.deckid !== 'undefined') {
            _path = {
                mcid: this.props.user_details.mcid,
                key: this.props.user_details.key,
                next: 0
            };
        } else {
            _path = {
                mcid: this.props.user_details.mcid,
                key: this.props.user_details.key,
                next: 0
            };
        }

        await this.props.resetDeck(obj);

        return this.handleSubmit(_path)
    }

    goReview = (obj) => {
        return this.setState({
            ...this.state,
            completed: 1,
            reviewObj: obj
        })
    }

    render() {
        if (this.state.completed === 1 && (typeof this.state.reviewObj === 'object' && this.state.reviewObj !== null)) {
            try {
                clearInterval(this.state.interval)
            } catch (e) {
            }

            return (
                <Redirect to={this.state.reviewObj} />

                // <LoadingCard textarray={['error page']} />
            )
        } else if (this.state.loading) {
            return (
                <LoadingCard textarray={this.state.loadingtext}/>
            )
        } else {
            try {
                clearInterval(this.state.interval)
            } catch (e) {
            }

            return (
                <>
                    <AILegalStatementCard in={hasLegal()} />
                    <div className=" aua-overflow" id="QuestionDiv">
                        <Typography className="homeDividerText">{this.state.text}</Typography>

                        <div className="question-container" >
                            {this.state.data.active === 1
                                ? (
                                    <QuestionTestCard 
                                        prevAnswer={this.state.prevAnswer}
                                        obj={this.state.data}
                                        text={this.state.text}
                                        answered={this.state.answered}
                                        type={this.state.type}
                                        typetext={this.state.typetext}
                                        spaced={this.state.spaced}
                                        gamemode={this.state.gamemode}
                                        year={this.state.year}
                                        deckid={this.state.deckid}
                                        submitFunc={this.handleSubmit}
                                        nextFunc={() => {console.log('next question')}}
                                        backFunc={() => {console.log('prev question')}}
                                        mykey={this.props.user_details.key}
                                        mcid={this.props.user_details.mcid}
                                        addNote={this.addNote}
                                        addToDecks={this.addToDecks}
                                        removeQuestion={this.removeQuestion}
                                        goReview={this.goReview}
                                        putNextReviewDate={this.props.putNextReviewDate}
                                        scrollToTop={this.scrollToTop}
                                        refsMats={this.state.refsMats}
                                        labs={this.props.user_details.labstest}
                                        deckList={this.props.deckList ? this.props.deckList : []}
                                        quizzes={this.props.quizzes ? this.props.quizzes : [] }
                                        id={'QuestionDiv'}
                                        resetDeck={this._reset}
                                        resetTest={this.resetTest}
                                        isstaff={this.props.user_details.isstaff ? this.props.user_details.isstaff : 0}
                                    />
                                ) 
                                : (
                                    <RetiredQuestionTestCard 
                                        prevAnswer={this.state.prevAnswer}
                                        obj={this.state.data}
                                        gamemode={this.state.gamemode}
                                        year={this.state.year}
                                        deckid={this.state.deckid ? this.state.deckid : 0}
                                        submitFunc={this.handleSubmit}
                                        mykey={this.props.user_details.key}
                                        mcid={this.props.user_details.mcid}
                                        scrollToTop={this.scrollToTop}
                                        deckList={this.props.deckList ? this.props.deckList : []}
                                        id={'QuestionDiv'}
                                    />
                                )
                            }
                            
                        </div>

                        <CopyrightWidget 
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-8 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                        />
                    </div>
                </>
            );
        }
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details } = state.auth;
    const { headerText, iconOne, iconTwo, backgroundcolor } = state.style;
    const { flashCards, deckList, quizzes } = state.decks;
    const { question, error } = state.question;

    return {
        headerText,
        iconOne,
        iconTwo,
        backgroundcolor,
        flashCards,
        auth_feedback,
        user_details,
        question, 
        deckList,
        error, 
        quizzes
    };
};

export default connect(mapStateToProps, 
    { 
        putResponse, getQuestion, getQuestionResults, addQuestionToDeck, updateHeaderInfo, putNextReviewDate, addNote, getUserDetails, removeQuestion, resetDeck, trackPage
    })(withRouter(QuestionTestScreen));

// export { QuestionTestScreen };
